import React from "react";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const RTEWrapper = styled.div`
    font-family: ${({theme}) => theme.font};
    line-height: 1.38;
    max-width: ${({maxWidth}) => (maxWidth ? maxWidth : "")};
    background-color: ${({bgColor}) => (bgColor ? bgColor : "")};
    font-weight: ${({bold}) => (bold ? "bold" : "normal")};
    color: ${({color, theme}) => (color ? color : theme.colors.primary)};

    table {
        color: ${({theme}) => theme.colors.black};
    }

    img {
        max-width: 100%;
        width: 100%;
        object-fit: contain;
        ${media.greaterThan(breakpoints.ipad)`
			width: unset !important;
			height: auto;
		`}
    }

    iframe {
        ${media.lessThan(breakpoints.ipad)`
			width: 100%;
			height: auto;
			min-height: 280px;
		`}
        ${media.lessThan(breakpoints.mobile)`
			width: 100%;
			height: auto;
			min-height: 200px;
		`}
    }

    p {
        margin: ${({pMargin}) => (pMargin ? pMargin : "")};

        margin-top: 0;
    }

    li:before {
        color: ${({theme}) => theme.colors.primary};
    }

    a {
        display: inline-block;
        color: ${({color, theme}) => (color ? color : theme.colors.primary)};
        transition: all 0.2s ease;
        border-bottom: ${({color, theme}) =>
                color ? `2px solid ${color}` : `2px solid ${theme.colors.primary}`};

        :hover,
        :focus {
            transition: all 0.2s ease;
            border-color: ${({theme}) => theme.colors.none};
        }
    }

    ${media.greaterThan(breakpoints.ipad)`
		font-size: ${({fontSize}) => (fontSize ? fontSize : "")};
	`}
`;
